import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
  Grid,
  Chip,
  IconButton,
  TextField,
  InputAdornment,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  Avatar,
  Divider,
  Badge,
  Tooltip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Switch,
  FormControlLabel,
  Slider,
  RadioGroup,
  Radio,
  Checkbox,
  FormGroup,
  Alert,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  Box,
  LinearProgress,
  CircularProgress,
  Tabs,
  Tab
} from '@mui/material';
import {
  Search as SearchIcon,
  FilterList as FilterIcon,
  MoreVert as MoreVertIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  Share as ShareIcon,
  Download as DownloadIcon,
  Add as AddIcon,
  Help as HelpIcon,
  Support as SupportIcon,
  ContactSupport as ContactSupportIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  LocationOn as LocationIcon,
  Business as BusinessIcon,
  Work as WorkIcon,
  School as SchoolIcon,
  Public as PublicIcon,
  Lock as LockIcon,
  VpnKey as VpnKeyIcon,
  Fingerprint as FingerprintIcon,
  Shield as ShieldIcon,
  VerifiedUser as VerifiedUserIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
  ManageAccounts as ManageAccountsIcon,
  AccountCircle as AccountCircleIcon,
  Badge as BadgeIcon,
  CreditCard as CreditCardIcon,
  Payment as PaymentIcon,
  Receipt as ReceiptIcon,
  AttachMoney as MoneyIcon,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  Assessment as AssessmentIcon,
  Analytics as AnalyticsIcon,
  Dashboard as DashboardIcon,
  Timeline as TimelineIcon,
  Schedule as ScheduleIcon,
  CalendarToday as CalendarIcon,
  AccessTime as AccessTimeIcon,
  Update as UpdateIcon,
  Refresh as RefreshIcon,
  Restore as RestoreIcon,
  Backup as BackupIcon,
  Archive as ArchiveIcon,
  DeleteForever as DeleteForeverIcon,
  RestoreFromTrash as RestoreFromTrashIcon,
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  InsertDriveFile as FileIcon,
  Image as ImageIcon,
  VideoLibrary as VideoIcon,
  AudioFile as AudioIcon,
  PictureAsPdf as PdfIcon,
  Description as DocumentIcon,
  TableChart as TableIcon,
  ShowChart as ChartIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  DonutLarge as DonutLargeIcon,
  ScatterPlot as ScatterPlotIcon,
  BubbleChart as BubbleChartIcon,
  MultilineChart as MultilineChartIcon,
  ShowChart as ShowChartIcon,
  TrendingFlat as TrendingFlatIcon,
  TrendingUp as TrendingUpIcon2,
  TrendingDown as TrendingDownIcon2,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Fullscreen as FullscreenIcon,
  FullscreenExit as FullscreenExitIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
  FitScreen as FitScreenIcon,
  CenterFocusStrong as CenterFocusStrongIcon,
  CenterFocusWeak as CenterFocusWeakIcon,
  CropFree as CropFreeIcon,
  CropSquare as CropSquareIcon,
  Crop as CropIcon,
  RotateLeft as RotateLeftIcon,
  RotateRight as RotateRightIcon,
  Flip as FlipIcon,
  Transform as TransformIcon,
  Straighten as StraightenIcon,
  Tune as TuneIcon,
  Adjust as AdjustIcon,
  Brightness4 as Brightness4Icon,
  Brightness7 as Brightness7Icon,
  Contrast as ContrastIcon,
  ColorLens as ColorLensIcon,
  Gradient as GradientIcon,
  Opacity as OpacityIcon,
  BlurOn as BlurOnIcon,
  BlurOff as BlurOffIcon,
  Filter as FilterIcon2,
  Filter1 as Filter1Icon,
  Filter2 as Filter2Icon,
  Filter3 as Filter3Icon,
  Filter4 as Filter4Icon,
  Filter5 as Filter5Icon,
  Filter6 as Filter6Icon,
  Filter7 as Filter7Icon,
  Filter8 as Filter8Icon,
  Filter9 as Filter9Icon,
  Filter9Plus as Filter9PlusIcon,
  FilterBAndW as FilterBAndWIcon,
  FilterCenterFocus as FilterCenterFocusIcon,
  FilterDrama as FilterDramaIcon,
  FilterFrames as FilterFramesIcon,
  FilterHdr as FilterHdrIcon,
  FilterNone as FilterNoneIcon,
  FilterTiltShift as FilterTiltShiftIcon,
  FilterVintage as FilterVintageIcon,
  Grain as GrainIcon,
  GridOn as GridOnIcon,
  GridOff as GridOffIcon,
  ViewModule as ViewModuleIcon,
  ViewList as ViewListIcon,
  ViewComfy as ViewComfyIcon,
  ViewCompact as ViewCompactIcon,
  ViewStream as ViewStreamIcon,
  ViewQuilt as ViewQuiltIcon,
  ViewCarousel as ViewCarouselIcon,
  ViewDay as ViewDayIcon,
  ViewWeek as ViewWeekIcon,
  ViewAgenda as ViewAgendaIcon,
  ViewHeadline as ViewHeadlineIcon,
  ViewSidebar as ViewSidebarIcon,
  ViewColumn as ViewColumnIcon,
  ViewArray as ViewArrayIcon,
  ViewKanban as ViewKanbanIcon,
  ViewTimeline as ViewTimelineIcon,
  Article as ArticleIcon,
  Campaign as CampaignIcon,
  ContactMail as ContactMailIcon,
  Public as PublicIcon2,
  Security as SecurityIcon2,
  Payment as PaymentIcon2,
  Assessment as AssessmentIcon2,
  TrendingUp as TrendingUpIcon3,
  TrendingDown as TrendingDownIcon3,
  Assignment as AssignmentIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  AssignmentLate as AssignmentLateIcon,
  AssignmentReturn as AssignmentReturnIcon,
  AssignmentReturned as AssignmentReturnedIcon,
  AssignmentInd as AssignmentIndIcon,
  AssignmentLate as AssignmentLateIcon2,
  AssignmentReturn as AssignmentReturnIcon2,
  AssignmentReturned as AssignmentReturnedIcon2,
  AssignmentInd as AssignmentIndIcon2,
  AssignmentLate as AssignmentLateIcon3,
  AssignmentReturn as AssignmentReturnIcon3,
  AssignmentReturned as AssignmentReturnedIcon3,
  AssignmentInd as AssignmentIndIcon3,
  AssignmentLate as AssignmentLateIcon4,
  AssignmentReturn as AssignmentReturnIcon4,
  AssignmentReturned as AssignmentReturnedIcon4,
  AssignmentInd as AssignmentIndIcon4,
  AssignmentLate as AssignmentLateIcon5,
  AssignmentReturn as AssignmentReturnIcon5,
  AssignmentReturned as AssignmentReturnedIcon5,
  AssignmentInd as AssignmentIndIcon5,
  AssignmentLate as AssignmentLateIcon6,
  AssignmentReturn as AssignmentReturnIcon6,
  AssignmentReturned as AssignmentReturnedIcon6,
  AssignmentInd as AssignmentIndIcon6,
  AssignmentLate as AssignmentLateIcon7,
  AssignmentReturn as AssignmentReturnIcon7,
  AssignmentReturned as AssignmentReturnedIcon7,
  AssignmentInd as AssignmentIndIcon7,
  AssignmentLate as AssignmentLateIcon8,
  AssignmentReturn as AssignmentReturnIcon8,
  AssignmentReturned as AssignmentReturnedIcon8,
  AssignmentInd as AssignmentIndIcon8,
  AssignmentLate as AssignmentLateIcon9,
  AssignmentReturn as AssignmentReturnIcon9,
  AssignmentReturned as AssignmentReturnedIcon9,
  AssignmentInd as AssignmentIndIcon9,
  AssignmentLate as AssignmentLateIcon10,
  AssignmentReturn as AssignmentReturnIcon10,
  AssignmentReturned as AssignmentReturnedIcon10,
  AssignmentInd as AssignmentIndIcon10,
  QuestionAnswer as QuestionAnswerIcon,
  LiveHelp as LiveHelpIcon,
  Chat as ChatIcon,
  Forum as ForumIcon,
  Feedback as FeedbackIcon,
  RateReview as RateReviewIcon,
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon,
  Book as BookIcon,
  MenuBook as MenuBookIcon,
  LibraryBooks as LibraryBooksIcon,
  School as SchoolIcon2,
  PlayCircleOutline as PlayCircleOutlineIcon,
  VideoCall as VideoCallIcon,
  Web as WebIcon,
  Language as LanguageIcon,
  Translate as TranslateIcon,
  GTranslate as GTranslateIcon,
  RecordVoiceOver as RecordVoiceOverIcon,
  Mic as MicIcon,
  MicOff as MicOffIcon,
  Headset as HeadsetIcon,
  HeadsetMic as HeadsetMicIcon,
  VolumeUp as VolumeUpIcon,
  VolumeDown as VolumeDownIcon,
  VolumeOff as VolumeOffIcon,
  VolumeMute as VolumeMuteIcon,
  Hearing as HearingIcon,
  HearingDisabled as HearingDisabledIcon,
  Accessibility as AccessibilityIcon,
  AccessibilityNew as AccessibilityNewIcon,
  SupportAgent as SupportAgentIcon,
  Engineering as EngineeringIcon,
  Build as BuildIcon,
  Construction as ConstructionIcon,
  Handyman as HandymanIcon,
  Plumbing as PlumbingIcon,
  ElectricalServices as ElectricalServicesIcon,
  CleaningServices as CleaningServicesIcon,
  PestControl as PestControlIcon,
  PestControlRodent as PestControlRodentIcon,
  Message as MessageIcon,
  Group as GroupIcon
} from '@mui/icons-material';
import Logo from '../common/Logo';
import { getFAQs, rateFAQ, getSupportTickets, createSupportTicket, updateSupportTicket, getSupportTicket, submitFeedback, FAQ, SupportTicket as APISupportTicket } from '../../services/supportApi';
import { getApiBaseUrl } from '../../utils/apiConfig';
import { generatePDF } from '../../utils/pdfGenerator';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`help-tabpanel-${index}`}
      aria-labelledby={`help-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div style={{ padding: '24px 0' }}>
          {children}
        </div>
      )}
    </div>
  );
}

interface SupportTicket {
  id: string;
  title: string;
  description: string;
  status: 'open' | 'in_progress' | 'resolved' | 'closed';
  priority: 'low' | 'medium' | 'high' | 'urgent';
  category: string;
  createdAt: string;
  updatedAt: string;
  assignedTo: string;
  responses: number;
}

const HelpSupportPage: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [expandedFAQ, setExpandedFAQ] = useState<string | false>(false);
  const [newTicketDialog, setNewTicketDialog] = useState(false);
  const [contactDialog, setContactDialog] = useState(false);
  const [feedbackDialog, setFeedbackDialog] = useState(false);
  const [apiDocsDialog, setApiDocsDialog] = useState(false);
  const [apiDocs, setApiDocs] = useState<any>(null);
  const [viewTicketDialog, setViewTicketDialog] = useState(false);
  const [editTicketDialog, setEditTicketDialog] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState<APISupportTicket | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [faqs, setFaqs] = useState<FAQ[]>([]);
  const [supportTickets, setSupportTickets] = useState<APISupportTicket[]>([]);
  const [faqRatings, setFaqRatings] = useState<Record<string, boolean | null>>({});
  const [ticketForm, setTicketForm] = useState({
    title: '',
    description: '',
    category: '',
    priority: 'medium'
  });
  const [feedbackForm, setFeedbackForm] = useState({
    rating: 0,
    likedMost: '',
    improvements: '',
    additionalComments: ''
  });

  // Load FAQs and tickets on component mount
  useEffect(() => {
    loadFAQs();
    loadTickets();
  }, []);

  const loadAPIDocs = () => {
    // API documentation is now frontend-only, showing only essential endpoints
    const docs = {
      title: 'Prowess PR Platform - API Documentation',
      version: '1.0.0',
      description: 'Essential API endpoints required for integrating with Prowess PR Platform',
      baseUrl: getApiBaseUrl(),
      endpoints: {
        authentication: {
          description: 'User authentication - Required for all API access',
          endpoints: [
            {
              method: 'POST',
              path: '/api/auth/login',
              description: 'Login and get authentication token (Required)',
              auth: false,
              requestBody: {
                email: 'string (required)',
                password: 'string (required)'
              },
              response: {
                token: 'JWT authentication token (use in Authorization header)',
                user: 'User object'
              }
            },
            {
              method: 'GET',
              path: '/api/auth/profile',
              description: 'Get current authenticated user profile (Required)',
              auth: true
            }
          ]
        },
        pressReleases: {
          description: 'Press release management - Core functionality',
          endpoints: [
            {
              method: 'POST',
              path: '/api/pr',
              description: 'Create a new press release (Required)',
              auth: true,
              requestBody: {
                title: 'string (required)',
                content: 'string (required)',
                contactInfo: {
                  name: 'string (required)',
                  email: 'string (required)',
                  company: 'string (required)',
                  phone: 'string (optional)'
                },
                targetAudience: 'array (optional)',
                geographicRegions: 'array (optional)'
              }
            },
            {
              method: 'GET',
              path: '/api/pr',
              description: 'Get list of user\'s press releases (Required)',
              auth: true,
              queryParams: {
                status: 'string (optional): draft, submitted, published',
                page: 'number (optional)',
                limit: 'number (optional)'
              }
            },
            {
              method: 'POST',
              path: '/api/pr/submit',
              description: 'Submit press release for distribution (Required)',
              auth: true,
              requestBody: {
                prId: 'string (required)',
                verified: 'boolean (required)'
              }
            }
          ]
        },
        distribution: {
          description: 'Distribution management - Required for publishing',
          endpoints: [
            {
              method: 'GET',
              path: '/api/distribution/channels',
              description: 'Get available distribution channels (Required)',
              auth: true,
              queryParams: {
                tier: 'string (optional): Tier1, Tier2, Tier3, Tier4'
              }
            },
            {
              method: 'POST',
              path: '/api/distribution',
              description: 'Create distribution for press release (Required)',
              auth: true,
              requestBody: {
                pressReleaseId: 'string (required)',
                channels: 'array (required)',
                paymentIntentId: 'string (required for paid channels)'
              }
            }
          ]
        },
        analytics: {
          description: 'Analytics and reporting - Required for tracking',
          endpoints: [
            {
              method: 'GET',
              path: '/api/timeline/events',
              description: 'Get timeline events and analytics (Required)',
              auth: true,
              queryParams: {
                startDate: 'string (optional): ISO date',
                endDate: 'string (optional): ISO date',
                type: 'string (optional): filter by event type'
              }
            }
          ]
        }
      },
      authentication: {
        description: 'All authenticated endpoints require a Bearer token in the Authorization header',
        example: 'Authorization: Bearer <your-jwt-token>',
        note: 'Get your token by logging in via POST /api/auth/login'
      },
      errors: {
        description: 'Standard error response format',
        format: {
          success: false,
          message: 'Error description'
        },
        statusCodes: {
          400: 'Bad Request - Invalid input parameters',
          401: 'Unauthorized - Missing or invalid authentication token',
          404: 'Not Found - Resource does not exist',
          500: 'Internal Server Error'
        }
      }
    };
    setApiDocs(docs);
  };

  const loadFAQs = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getFAQs(selectedCategory === 'all' ? undefined : selectedCategory, searchTerm || undefined);
      if (response.success) {
        setFaqs(response.faqs);
      }
    } catch (err: any) {
      console.error('Error loading FAQs:', err);
      setError(err.message || 'Failed to load FAQs');
    } finally {
      setLoading(false);
    }
  };

  const loadTickets = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getSupportTickets();
      if (response.success) {
        setSupportTickets(response.tickets);
      }
    } catch (err: any) {
      console.error('Error loading tickets:', err);
      setError(err.message || 'Failed to load support tickets');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadFAQs();
  }, [selectedCategory, searchTerm]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleFAQExpand = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpandedFAQ(isExpanded ? panel : false);
  };

  const handleCreateTicket = () => {
    setNewTicketDialog(true);
  };

  const handleSubmitTicket = async () => {
    if (!ticketForm.title || !ticketForm.description || !ticketForm.category) {
      setError('Please fill in all required fields');
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const response = await createSupportTicket({
        title: ticketForm.title,
        description: ticketForm.description,
        category: ticketForm.category,
        priority: ticketForm.priority as 'low' | 'medium' | 'high' | 'urgent'
      });
      if (response.success) {
        setNewTicketDialog(false);
        setTicketForm({ title: '', description: '', category: '', priority: 'medium' });
        await loadTickets();
      }
    } catch (err: any) {
      console.error('Error creating ticket:', err);
      setError(err.message || 'Failed to create ticket');
    } finally {
      setLoading(false);
    }
  };

  const handleRateFAQ = async (faqId: string, isHelpful: boolean) => {
    try {
      const response = await rateFAQ(faqId, isHelpful);
      if (response.success) {
        setFaqRatings({ ...faqRatings, [faqId]: isHelpful });
        // Update the FAQ in the list
        setFaqs(faqs.map(faq => faq._id === faqId ? response.faq : faq));
      }
    } catch (err: any) {
      console.error('Error rating FAQ:', err);
      setError(err.message || 'Failed to rate FAQ');
    }
  };

  const handleSubmitFeedback = async () => {
    if (!feedbackForm.rating || feedbackForm.rating < 1 || feedbackForm.rating > 5) {
      setError('Please provide a rating between 1 and 5');
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const response = await submitFeedback({
        rating: feedbackForm.rating,
        likedMost: feedbackForm.likedMost || undefined,
        improvements: feedbackForm.improvements || undefined,
        additionalComments: feedbackForm.additionalComments || undefined
      });
      if (response.success) {
        setFeedbackDialog(false);
        setFeedbackForm({ rating: 0, likedMost: '', improvements: '', additionalComments: '' });
      }
    } catch (err: any) {
      console.error('Error submitting feedback:', err);
      setError(err.message || 'Failed to submit feedback');
    } finally {
      setLoading(false);
    }
  };

  const filteredFAQs = faqs.filter(faq => {
    const matchesSearch = !searchTerm || 
                         faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         faq.answer.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         (faq.tags && faq.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase())));
    const matchesCategory = selectedCategory === 'all' || faq.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'open': return '#FF9800';
      case 'in_progress': return '#2196F3';
      case 'resolved': return '#4CAF50';
      case 'closed': return '#9E9E9E';
      default: return '#9E9E9E';
    }
  };

  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'urgent': return '#F44336';
      case 'high': return '#FF5722';
      case 'medium': return '#FF9800';
      case 'low': return '#4CAF50';
      default: return '#9E9E9E';
    }
  };

  return (
    <Container maxWidth="xl" style={{ padding: '24px' }}>
      {/* Header */}
      <div style={{ marginBottom: '32px' }}>
        <Typography variant="h4" style={{ fontWeight: 'bold', color: '#0927eb', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <HelpIcon style={{ fontSize: '32px' }} />
          Help & Support
        </Typography>
        <Typography variant="body1" style={{ color: '#666' }}>
          Get help, find answers, and connect with our support team
        </Typography>
      </div>

      {/* Quick Actions */}
      <Grid container spacing={3} style={{ marginBottom: '32px' }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card style={{ borderRadius: '12px', textAlign: 'center', padding: '24px' }}>
            <CardContent>
              <ContactSupportIcon style={{ fontSize: '48px', color: '#0927eb', marginBottom: '16px' }} />
              <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                Contact Support
              </Typography>
              <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
                Get help from our support team
              </Typography>
              <Button
                variant="contained"
                onClick={() => setContactDialog(true)}
                style={{
                  backgroundColor: '#000000',
                  color: 'white'
                }}
              >
                Contact Us
              </Button>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card style={{ borderRadius: '12px', textAlign: 'center', padding: '24px' }}>
            <CardContent>
              <AddIcon style={{ fontSize: '48px', color: '#0927eb', marginBottom: '16px' }} />
              <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                Create Ticket
              </Typography>
              <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
                Submit a support ticket
              </Typography>
              <Button
                variant="outlined"
                onClick={handleCreateTicket}
                style={{
                  borderColor: '#000000',
                  color: '#000000'
                }}
              >
                New Ticket
              </Button>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card style={{ borderRadius: '12px', textAlign: 'center', padding: '24px' }}>
            <CardContent>
              <FeedbackIcon style={{ fontSize: '48px', color: '#0927eb', marginBottom: '16px' }} />
              <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                Give Feedback
              </Typography>
              <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
                Share your thoughts with us
              </Typography>
              <Button
                variant="outlined"
                onClick={() => setFeedbackDialog(true)}
                style={{
                  borderColor: '#000000',
                  color: '#000000'
                }}
              >
                Feedback
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Main Content Tabs */}
      <Paper style={{ borderRadius: '12px', marginBottom: '24px' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          style={{ borderBottom: '1px solid #e0e0e0' }}
        >
          <Tab
            icon={<QuestionAnswerIcon />}
            label="FAQ"
            iconPosition="start"
            style={{ minHeight: '64px' }}
          />
          <Tab
            icon={<SupportIcon />}
            label="Support Tickets"
            iconPosition="start"
            style={{ minHeight: '64px' }}
          />
          <Tab
            icon={<BookIcon />}
            label="Documentation"
            iconPosition="start"
            style={{ minHeight: '64px' }}
          />
          <Tab
            icon={<VideoCallIcon />}
            label="Video Tutorials"
            iconPosition="start"
            style={{ minHeight: '64px' }}
          />
        </Tabs>

        {/* FAQ Tab */}
        <TabPanel value={tabValue} index={0}>
          <div style={{ padding: '24px' }}>
            {/* Search and Filter */}
            <div style={{ marginBottom: '24px' }}>
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    placeholder="Search FAQ..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon style={{ color: '#666' }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControl fullWidth>
                    <InputLabel>Category</InputLabel>
                    <Select
                      value={selectedCategory}
                      onChange={(e) => setSelectedCategory(e.target.value)}
                      label="Category"
                    >
                      <MenuItem value="all">All Categories</MenuItem>
                      <MenuItem value="Getting Started">Getting Started</MenuItem>
                      <MenuItem value="Billing">Billing</MenuItem>
                      <MenuItem value="Analytics">Analytics</MenuItem>
                      <MenuItem value="Features">Features</MenuItem>
                      <MenuItem value="Team Management">Team Management</MenuItem>
                      <MenuItem value="Distribution">Distribution</MenuItem>
                      <MenuItem value="Security">Security</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography variant="body2" style={{ color: '#666' }}>
                    {filteredFAQs.length} results found
                  </Typography>
                </Grid>
              </Grid>
            </div>

            {/* FAQ List */}
            <div>
              {loading && <CircularProgress style={{ margin: '20px auto', display: 'block' }} />}
              {error && <Alert severity="error" style={{ marginBottom: '16px' }}>{error}</Alert>}
              {!loading && filteredFAQs.length === 0 && (
                <Typography variant="body1" style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                  No FAQs found. Try adjusting your search or category filter.
                </Typography>
              )}
              {filteredFAQs.map((faq) => (
                <Accordion
                  key={faq._id}
                  expanded={expandedFAQ === faq._id}
                  onChange={handleFAQExpand(faq._id)}
                  style={{ marginBottom: '8px', borderRadius: '8px' }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <Typography variant="h6" style={{ fontWeight: 'bold', flex: 1 }}>
                        {faq.question}
                      </Typography>
                      <Chip
                        label={faq.category}
                        size="small"
                        style={{ marginRight: '16px' }}
                      />
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body1" style={{ marginBottom: '16px' }}>
                      {faq.answer}
                    </Typography>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                      <Typography variant="body2" style={{ color: '#666' }}>
                        Was this helpful?
                      </Typography>
                      <Button
                        size="small"
                        startIcon={<ThumbUpIcon />}
                        onClick={() => handleRateFAQ(faq._id, true)}
                        style={{ 
                          color: faqRatings[faq._id] === true ? '#4CAF50' : '#666',
                          backgroundColor: faqRatings[faq._id] === true ? 'rgba(76, 175, 80, 0.1)' : 'transparent'
                        }}
                      >
                        {faq.helpful || 0}
                      </Button>
                      <Button
                        size="small"
                        startIcon={<ThumbDownIcon />}
                        onClick={() => handleRateFAQ(faq._id, false)}
                        style={{ 
                          color: faqRatings[faq._id] === false ? '#F44336' : '#666',
                          backgroundColor: faqRatings[faq._id] === false ? 'rgba(244, 67, 54, 0.1)' : 'transparent',
                          display: 'none' // Hide dislike button as per requirements
                        }}
                      />
                      <div style={{ marginLeft: 'auto' }}>
                        {faq.tags && faq.tags.map((tag, index) => (
                          <Chip
                            key={index}
                            label={tag}
                            size="small"
                            style={{ marginRight: '4px', marginBottom: '4px' }}
                          />
                        ))}
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}
            </div>
          </div>
        </TabPanel>

        {/* Support Tickets Tab */}
        <TabPanel value={tabValue} index={1}>
          <div style={{ padding: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
              <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                Your Support Tickets
              </Typography>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleCreateTicket}
                style={{
                  backgroundColor: '#000000',
                  color: 'white'
                }}
              >
                New Ticket
              </Button>
            </div>

            <TableContainer component={Paper} style={{ borderRadius: '12px' }}>
              <Table>
                <TableHead>
                  <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                    <TableCell style={{ fontWeight: 'bold' }}>Ticket ID</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Title</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Priority</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Category</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Created</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Responses</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading && (
                    <TableRow>
                      <TableCell colSpan={8} style={{ textAlign: 'center', padding: '40px' }}>
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  )}
                  {error && (
                    <TableRow>
                      <TableCell colSpan={8} style={{ textAlign: 'center', padding: '20px' }}>
                        <Alert severity="error">{error}</Alert>
                      </TableCell>
                    </TableRow>
                  )}
                  {!loading && supportTickets.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={8} style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                        No support tickets found. Create your first ticket to get started.
                      </TableCell>
                    </TableRow>
                  )}
                  {supportTickets.map((ticket) => (
                    <TableRow key={ticket._id} hover>
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                          {ticket.ticketId}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                          {ticket.title}
                        </Typography>
                        <Typography variant="body2" style={{ color: '#666' }}>
                          {ticket.description}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={ticket.status.charAt(0).toUpperCase() + ticket.status.slice(1).replace('_', ' ')}
                          style={{
                            backgroundColor: getStatusColor(ticket.status),
                            color: 'white',
                            fontWeight: 'bold'
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={ticket.priority.charAt(0).toUpperCase() + ticket.priority.slice(1)}
                          style={{
                            backgroundColor: getPriorityColor(ticket.priority),
                            color: 'white',
                            fontWeight: 'bold'
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {ticket.category}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {new Date(ticket.createdAt).toLocaleDateString()}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Badge badgeContent={ticket.responses} color="primary">
                          <MessageIcon />
                        </Badge>
                      </TableCell>
                      <TableCell>
                        <Tooltip title="View Ticket">
                          <IconButton 
                            size="small"
                            onClick={() => {
                              setSelectedTicket(ticket);
                              setViewTicketDialog(true);
                            }}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Edit Ticket">
                          <IconButton 
                            size="small"
                            onClick={() => {
                              setSelectedTicket(ticket);
                              setTicketForm({
                                title: ticket.title,
                                description: ticket.description,
                                category: ticket.category,
                                priority: ticket.priority
                              });
                              setEditTicketDialog(true);
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </TabPanel>

        {/* Documentation Tab */}
        <TabPanel value={tabValue} index={2}>
          <div style={{ padding: '24px' }}>
            <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '24px' }}>
              Documentation & Guides
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Card style={{ borderRadius: '12px' }}>
                  <CardContent>
                    <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '16px' }}>
                      Getting Started Guide
                    </Typography>
                    <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
                      Learn the basics of using Prowess PR Platform
                    </Typography>
                    <Button
                      variant="outlined"
                      startIcon={<DownloadIcon />}
                      onClick={() => {
                        const content = `# Getting Started Guide - Prowess PR Platform

## Welcome to Prowess PR Platform

This guide will help you get started with creating and distributing press releases.

## Creating Your First Press Release

1. Navigate to the "Create PR" section from the main menu
2. Click "New Press Release" 
3. Fill in the required information:
   - Title: A compelling headline for your press release
   - Content: The main body of your press release
   - Contact Information: Your name, email, company, and phone
   - Target Audience: Who you want to reach
   - Geographic Regions: Where you want to distribute

4. Use our AI-powered content suggestions to optimize your press release
5. Review and submit your press release

## Distribution Process

After submission, your press release goes through:
1. AI Analysis - Content quality and optimization suggestions
2. Verification - Review and approval process
3. Distribution - Selection of publishing channels
4. Publication - Your PR goes live on selected channels

## Analytics

Track your press release performance:
- Views and impressions
- Click-through rates
- Engagement metrics
- ROI calculations

For more information, visit our platform or contact support.`;
                        generatePDF(content, 'Getting-Started-Guide.pdf');
                      }}
                      style={{
                        borderColor: '#000000',
                        color: '#000000'
                      }}
                    >
                      Download PDF
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card style={{ borderRadius: '12px' }}>
                  <CardContent>
                    <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '16px' }}>
                      API Documentation
                    </Typography>
                    <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
                      Complete API reference and integration guides
                    </Typography>
                    <Button
                      variant="outlined"
                      startIcon={<WebIcon />}
                      onClick={() => {
                        setApiDocsDialog(true);
                        if (!apiDocs) {
                          loadAPIDocs();
                        }
                      }}
                      style={{
                        borderColor: '#000000',
                        color: '#000000'
                      }}
                    >
                      View API Docs
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card style={{ borderRadius: '12px' }}>
                  <CardContent>
                    <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '16px' }}>
                      Best Practices Guide
                    </Typography>
                    <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
                      Tips and best practices for effective PR campaigns
                    </Typography>
                    <Button
                      variant="outlined"
                      startIcon={<DownloadIcon />}
                      onClick={() => {
                        const content = `# Best Practices Guide - Prowess PR Platform

## Tips for Effective PR Campaigns

### Content Creation
- Write clear, concise headlines
- Include relevant quotes and data
- Use proper formatting and structure
- Include contact information

### Distribution Strategy
- Choose appropriate channels for your audience
- Consider geographic targeting
- Time your releases strategically
- Track and analyze performance

### Engagement
- Respond to media inquiries promptly
- Monitor your press release performance
- Use analytics to improve future campaigns

For more tips, visit our platform.`;
                        generatePDF(content, 'Best-Practices-Guide.pdf');
                      }}
                      style={{
                        borderColor: '#000000',
                        color: '#000000'
                      }}
                    >
                      Download PDF
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card style={{ borderRadius: '12px' }}>
                  <CardContent>
                    <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '16px' }}>
                      Troubleshooting Guide
                    </Typography>
                    <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
                      Common issues and their solutions
                    </Typography>
                    <Button
                      variant="outlined"
                      startIcon={<DownloadIcon />}
                      onClick={() => {
                        const content = `# Troubleshooting Guide - Prowess PR Platform

## Common Issues and Solutions

### Upload Issues
- Ensure file size is under 10MB
- Supported formats: PDF, DOC, DOCX, TXT
- Check your internet connection

### Payment Issues
- Verify your payment method
- Check for sufficient funds
- Contact billing support if charges appear incorrectly

### Analytics Not Updating
- Allow 24-48 hours for data to sync
- Clear your browser cache
- Check your date range filters

### Distribution Problems
- Verify your press release is approved
- Check channel availability
- Contact support for assistance

For additional help, create a support ticket or contact our team.`;
                        generatePDF(content, 'Troubleshooting-Guide.pdf');
                      }}
                      style={{
                        borderColor: '#000000',
                        color: '#000000'
                      }}
                    >
                      Download PDF
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </div>
        </TabPanel>

        {/* Video Tutorials Tab */}
        <TabPanel value={tabValue} index={3}>
          <div style={{ padding: '24px' }}>
            <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '24px' }}>
              Video Tutorials
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={4}>
                <Card style={{ borderRadius: '12px' }}>
                  <CardContent>
                    <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                      <PlayCircleOutlineIcon style={{ fontSize: '64px', color: '#0927eb' }} />
                    </div>
                    <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                      Platform Overview
                    </Typography>
                    <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
                      5:30 min • Getting Started
                    </Typography>
                    <Button
                      variant="contained"
                      startIcon={<PlayCircleOutlineIcon />}
                      fullWidth
                      style={{
                        backgroundColor: '#000000',
                        color: 'white'
                      }}
                    >
                      Watch Now
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Card style={{ borderRadius: '12px' }}>
                  <CardContent>
                    <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                      <PlayCircleOutlineIcon style={{ fontSize: '64px', color: '#0927eb' }} />
                    </div>
                    <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                      Creating Press Releases
                    </Typography>
                    <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
                      8:15 min • Features
                    </Typography>
                    <Button
                      variant="contained"
                      startIcon={<PlayCircleOutlineIcon />}
                      fullWidth
                      style={{
                        backgroundColor: '#000000',
                        color: 'white'
                      }}
                    >
                      Watch Now
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Card style={{ borderRadius: '12px' }}>
                  <CardContent>
                    <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                      <PlayCircleOutlineIcon style={{ fontSize: '64px', color: '#0927eb' }} />
                    </div>
                    <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                      Analytics Dashboard
                    </Typography>
                    <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
                      6:45 min • Analytics
                    </Typography>
                    <Button
                      variant="contained"
                      startIcon={<PlayCircleOutlineIcon />}
                      fullWidth
                      style={{
                        backgroundColor: '#000000',
                        color: 'white'
                      }}
                    >
                      Watch Now
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </div>
        </TabPanel>

      </Paper>

      {/* Contact Support Dialog */}
      <Dialog open={contactDialog} onClose={() => setContactDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Contact Support</DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Card style={{ borderRadius: '12px', textAlign: 'center', padding: '24px' }}>
                <CardContent>
                  <EmailIcon style={{ fontSize: '48px', color: '#0927eb', marginBottom: '16px' }} />
                  <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                    Email Support
                  </Typography>
                  <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
                    support@prowess.com
                  </Typography>
                  <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
                    Response time: 2-4 hours
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<EmailIcon />}
                    href={`mailto:support@prowess.com?subject=Support Request`}
                    style={{
                      backgroundColor: '#000000',
                      color: 'white'
                    }}
                  >
                    Send Email
                  </Button>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card style={{ borderRadius: '12px', textAlign: 'center', padding: '24px' }}>
                <CardContent>
                  <PhoneIcon style={{ fontSize: '48px', color: '#0927eb', marginBottom: '16px' }} />
                  <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                    Phone Support
                  </Typography>
                  <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
                    +1 (555) 123-4567
                  </Typography>
                  <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
                    Mon-Fri 9AM-6PM PST
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<PhoneIcon />}
                    href="tel:+15551234567"
                    style={{
                      backgroundColor: '#000000',
                      color: 'white'
                    }}
                  >
                    Call Now
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setContactDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* View Ticket Dialog */}
      <Dialog open={viewTicketDialog} onClose={() => {
        setViewTicketDialog(false);
        setSelectedTicket(null);
      }} maxWidth="md" fullWidth>
        <DialogTitle>
          <Typography variant="h6" style={{ fontWeight: 'bold' }}>
            Ticket Details
          </Typography>
          {selectedTicket && (
            <Typography variant="body2" style={{ color: '#666', marginTop: '8px' }}>
              {selectedTicket.ticketId}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          {selectedTicket && (
            <Grid container spacing={3} style={{ marginTop: '8px' }}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#666', marginBottom: '4px' }}>
                  Title
                </Typography>
                <Typography variant="body1" style={{ marginBottom: '16px' }}>
                  {selectedTicket.title}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#666', marginBottom: '4px' }}>
                  Description
                </Typography>
                <Typography variant="body1" style={{ marginBottom: '16px', whiteSpace: 'pre-wrap' }}>
                  {selectedTicket.description}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#666', marginBottom: '4px' }}>
                  Status
                </Typography>
                <Chip
                  label={selectedTicket.status.charAt(0).toUpperCase() + selectedTicket.status.slice(1).replace('_', ' ')}
                  style={{
                    backgroundColor: getStatusColor(selectedTicket.status),
                    color: 'white',
                    fontWeight: 'bold'
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#666', marginBottom: '4px' }}>
                  Priority
                </Typography>
                <Chip
                  label={selectedTicket.priority.charAt(0).toUpperCase() + selectedTicket.priority.slice(1)}
                  style={{
                    backgroundColor: getPriorityColor(selectedTicket.priority),
                    color: 'white',
                    fontWeight: 'bold'
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#666', marginBottom: '4px' }}>
                  Category
                </Typography>
                <Typography variant="body1">
                  {selectedTicket.category}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#666', marginBottom: '4px' }}>
                  Created
                </Typography>
                <Typography variant="body1">
                  {new Date(selectedTicket.createdAt).toLocaleString()}
                </Typography>
              </Grid>
              {selectedTicket.assignedTo && (
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#666', marginBottom: '4px' }}>
                    Assigned To
                  </Typography>
                  <Typography variant="body1">
                    {selectedTicket.assignedTo}
                  </Typography>
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#666', marginBottom: '4px' }}>
                  Responses
                </Typography>
                <Badge badgeContent={selectedTicket.responses} color="primary">
                  <MessageIcon />
                </Badge>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setViewTicketDialog(false);
            setSelectedTicket(null);
          }}>
            Close
          </Button>
          {selectedTicket && (
            <Button
              variant="contained"
              startIcon={<EditIcon />}
              onClick={() => {
                setViewTicketDialog(false);
                setTicketForm({
                  title: selectedTicket.title,
                  description: selectedTicket.description,
                  category: selectedTicket.category,
                  priority: selectedTicket.priority
                });
                setEditTicketDialog(true);
              }}
              style={{
                backgroundColor: '#000000',
                color: 'white'
              }}
            >
              Edit Ticket
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* New Ticket Dialog */}
      <Dialog 
        open={newTicketDialog} 
        onClose={() => {
          setNewTicketDialog(false);
          setTicketForm({ title: '', description: '', category: '', priority: 'medium' });
        }} 
        maxWidth="md" 
        fullWidth
      >
        <DialogTitle>Create Support Ticket</DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Ticket Title"
                value={ticketForm.title}
                onChange={(e) => setTicketForm({ ...ticketForm, title: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Category</InputLabel>
                <Select
                  value={ticketForm.category}
                  onChange={(e) => setTicketForm({ ...ticketForm, category: e.target.value })}
                  label="Category"
                >
                  <MenuItem value="Technical Issue">Technical Issue</MenuItem>
                  <MenuItem value="Billing">Billing</MenuItem>
                  <MenuItem value="Feature Request">Feature Request</MenuItem>
                  <MenuItem value="Account">Account</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Priority</InputLabel>
                <Select
                  value={ticketForm.priority}
                  onChange={(e) => setTicketForm({ ...ticketForm, priority: e.target.value })}
                  label="Priority"
                >
                  <MenuItem value="low">Low</MenuItem>
                  <MenuItem value="medium">Medium</MenuItem>
                  <MenuItem value="high">High</MenuItem>
                  <MenuItem value="urgent">Urgent</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                multiline
                rows={6}
                value={ticketForm.description}
                onChange={(e) => setTicketForm({ ...ticketForm, description: e.target.value })}
                placeholder="Please provide detailed information about your issue..."
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {error && <Alert severity="error" style={{ marginRight: 'auto', marginLeft: '16px' }}>{error}</Alert>}
          <Button onClick={() => setNewTicketDialog(false)} disabled={loading}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleSubmitTicket}
            disabled={loading}
            style={{
              backgroundColor: '#000000',
              color: 'white'
            }}
          >
            {loading ? <CircularProgress size={20} /> : 'Submit Ticket'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Ticket Dialog */}
      <Dialog 
        open={editTicketDialog} 
        onClose={() => {
          setEditTicketDialog(false);
          setSelectedTicket(null);
          setTicketForm({ title: '', description: '', category: '', priority: 'medium' });
        }} 
        maxWidth="md" 
        fullWidth
      >
        <DialogTitle>Edit Support Ticket</DialogTitle>
        <DialogContent>
          {selectedTicket && (
            <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
              Ticket ID: {selectedTicket.ticketId}
            </Typography>
          )}
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Ticket Title"
                value={ticketForm.title}
                onChange={(e) => setTicketForm({ ...ticketForm, title: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Category</InputLabel>
                <Select
                  value={ticketForm.category}
                  onChange={(e) => setTicketForm({ ...ticketForm, category: e.target.value })}
                  label="Category"
                >
                  <MenuItem value="Technical Issue">Technical Issue</MenuItem>
                  <MenuItem value="Billing">Billing</MenuItem>
                  <MenuItem value="Feature Request">Feature Request</MenuItem>
                  <MenuItem value="Account">Account</MenuItem>
                  <MenuItem value="Analytics">Analytics</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Priority</InputLabel>
                <Select
                  value={ticketForm.priority}
                  onChange={(e) => setTicketForm({ ...ticketForm, priority: e.target.value })}
                  label="Priority"
                >
                  <MenuItem value="low">Low</MenuItem>
                  <MenuItem value="medium">Medium</MenuItem>
                  <MenuItem value="high">High</MenuItem>
                  <MenuItem value="urgent">Urgent</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                multiline
                rows={6}
                value={ticketForm.description}
                onChange={(e) => setTicketForm({ ...ticketForm, description: e.target.value })}
                placeholder="Please provide detailed information about your issue..."
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {error && <Alert severity="error" style={{ marginRight: 'auto', marginLeft: '16px' }}>{error}</Alert>}
          <Button 
            onClick={() => {
              setEditTicketDialog(false);
              setSelectedTicket(null);
              setTicketForm({ title: '', description: '', category: '', priority: 'medium' });
            }} 
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmitTicket}
            disabled={loading}
            style={{
              backgroundColor: '#000000',
              color: 'white'
            }}
          >
            {loading ? <CircularProgress size={20} /> : 'Update Ticket'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Feedback Dialog */}
      <Dialog open={feedbackDialog} onClose={() => setFeedbackDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Give Feedback</DialogTitle>
        <DialogContent>
          {error && <Alert severity="error" style={{ marginBottom: '16px' }}>{error}</Alert>}
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControl component="fieldset">
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                  How would you rate your experience?
                </Typography>
                <RadioGroup 
                  row
                  value={feedbackForm.rating.toString()}
                  onChange={(e) => setFeedbackForm({ ...feedbackForm, rating: parseInt(e.target.value) })}
                >
                  <FormControlLabel value="1" control={<Radio />} label="1" />
                  <FormControlLabel value="2" control={<Radio />} label="2" />
                  <FormControlLabel value="3" control={<Radio />} label="3" />
                  <FormControlLabel value="4" control={<Radio />} label="4" />
                  <FormControlLabel value="5" control={<Radio />} label="5" />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="What did you like most?"
                multiline
                rows={3}
                value={feedbackForm.likedMost}
                onChange={(e) => setFeedbackForm({ ...feedbackForm, likedMost: e.target.value })}
                placeholder="Tell us what you enjoyed about using Prowess..."
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="What could we improve?"
                multiline
                rows={3}
                value={feedbackForm.improvements}
                onChange={(e) => setFeedbackForm({ ...feedbackForm, improvements: e.target.value })}
                placeholder="Share suggestions for improvement..."
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Additional Comments"
                multiline
                rows={3}
                value={feedbackForm.additionalComments}
                onChange={(e) => setFeedbackForm({ ...feedbackForm, additionalComments: e.target.value })}
                placeholder="Any other feedback you'd like to share..."
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFeedbackDialog(false)} disabled={loading}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleSubmitFeedback}
            disabled={loading || !feedbackForm.rating}
            style={{
              backgroundColor: '#000000',
              color: 'white'
            }}
          >
            {loading ? <CircularProgress size={20} /> : 'Submit Feedback'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* API Documentation Dialog */}
      <Dialog 
        open={apiDocsDialog} 
        onClose={() => setApiDocsDialog(false)} 
        maxWidth="lg" 
        fullWidth
      >
        <DialogTitle>
          <Typography variant="h5" style={{ fontWeight: 'bold', color: '#0927eb' }}>
            API Documentation
          </Typography>
          <Typography variant="body2" style={{ color: '#666', marginTop: '8px' }}>
            Essential API endpoints for integrating with Prowess PR Platform
          </Typography>
        </DialogTitle>
        <DialogContent>
          {apiDocs && (
            <div style={{ padding: '16px 0' }}>
              <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '16px', marginTop: '16px' }}>
                Base URL
              </Typography>
              <code style={{ 
                display: 'block', 
                padding: '8px', 
                backgroundColor: '#f5f5f5', 
                borderRadius: '4px',
                marginBottom: '24px'
              }}>
                {apiDocs.baseUrl}
              </code>

              <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '16px', marginTop: '24px' }}>
                Authentication
              </Typography>
              <Typography variant="body2" style={{ marginBottom: '16px', color: '#666' }}>
                {apiDocs.authentication.description}
              </Typography>
              <code style={{ 
                display: 'block', 
                padding: '8px', 
                backgroundColor: '#f5f5f5', 
                borderRadius: '4px',
                marginBottom: '16px'
              }}>
                {apiDocs.authentication.example}
              </code>

              {Object.entries(apiDocs.endpoints).map(([category, data]: [string, any]) => (
                <div key={category} style={{ marginBottom: '32px' }}>
                  <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '8px', textTransform: 'capitalize' }}>
                    {category.replace(/([A-Z])/g, ' $1').trim()}
                  </Typography>
                  <Typography variant="body2" style={{ color: '#666', marginBottom: '16px' }}>
                    {data.description}
                  </Typography>
                  {data.endpoints.map((endpoint: any, idx: number) => (
                    <Card key={idx} style={{ marginBottom: '12px', backgroundColor: '#fafafa' }}>
                      <CardContent>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                          <Chip 
                            label={endpoint.method} 
                            style={{ 
                              backgroundColor: endpoint.method === 'GET' ? '#4CAF50' : endpoint.method === 'POST' ? '#2196F3' : '#FF9800',
                              color: 'white',
                              fontWeight: 'bold'
                            }}
                            size="small"
                          />
                          <code style={{ flex: 1, fontSize: '14px' }}>{endpoint.path}</code>
                          {endpoint.auth && (
                            <Chip label="Auth Required" size="small" color="warning" />
                          )}
                        </div>
                        <Typography variant="body2" style={{ marginBottom: '8px' }}>
                          {endpoint.description}
                        </Typography>
                        {endpoint.requestBody && (
                          <div style={{ marginTop: '8px' }}>
                            <Typography variant="caption" style={{ fontWeight: 'bold' }}>Request Body:</Typography>
                            <pre style={{ 
                              marginTop: '4px', 
                              padding: '8px', 
                              backgroundColor: '#f5f5f5', 
                              borderRadius: '4px',
                              fontSize: '12px',
                              overflowX: 'auto'
                            }}>
                              {JSON.stringify(endpoint.requestBody, null, 2)}
                            </pre>
                          </div>
                        )}
                        {endpoint.queryParams && (
                          <div style={{ marginTop: '8px' }}>
                            <Typography variant="caption" style={{ fontWeight: 'bold' }}>Query Parameters:</Typography>
                            <pre style={{ 
                              marginTop: '4px', 
                              padding: '8px', 
                              backgroundColor: '#f5f5f5', 
                              borderRadius: '4px',
                              fontSize: '12px',
                              overflowX: 'auto'
                            }}>
                              {JSON.stringify(endpoint.queryParams, null, 2)}
                            </pre>
                          </div>
                        )}
                      </CardContent>
                    </Card>
                  ))}
                </div>
              ))}

              <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '16px', marginTop: '32px' }}>
                Error Responses
              </Typography>
              <Typography variant="body2" style={{ marginBottom: '8px' }}>
                {apiDocs.errors.description}
              </Typography>
              <div style={{ marginTop: '16px' }}>
                {Object.entries(apiDocs.errors.statusCodes).map(([code, message]: [string, any]) => (
                  <div key={code} style={{ marginBottom: '8px' }}>
                    <strong>{code}:</strong> {message}
                  </div>
                ))}
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setApiDocsDialog(false)}>Close</Button>
          {apiDocs && (
            <Button
              variant="contained"
              startIcon={<DownloadIcon />}
              onClick={() => {
                const content = `# ${apiDocs.title}\n\nVersion: ${apiDocs.version}\n\n${apiDocs.description}\n\n## Base URL\n${apiDocs.baseUrl}\n\n## Authentication\n${apiDocs.authentication.description}\n\n${apiDocs.authentication.example}\n\n## Endpoints\n\n${Object.entries(apiDocs.endpoints).map(([cat, data]: [string, any]) => 
              `### ${cat}\n${data.description}\n\n${data.endpoints.map((e: any) => 
                `**${e.method}** ${e.path}\n${e.description}\n${e.requestBody ? `Request: ${JSON.stringify(e.requestBody, null, 2)}\n` : ''}${e.queryParams ? `Query: ${JSON.stringify(e.queryParams, null, 2)}\n` : ''}`
              ).join('\n')}`
            ).join('\n\n')}`;
                generatePDF(content, 'API-Documentation.pdf');
              }}
              style={{
                backgroundColor: '#000000',
                color: 'white'
              }}
            >
              Download PDF
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default HelpSupportPage;